import React from 'react';
import profileImage from '../assets/Asset 1.svg';

function Hero() {
    return (
        <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black pt-20">
            {/* Background Glows */}
            <div className="absolute top-1/4 -left-20 w-96 h-96 bg-green-500/10 rounded-full blur-[120px] animate-pulse"></div>
            <div className="absolute bottom-1/4 -right-20 w-96 h-96 bg-green-500/10 rounded-full blur-[120px] animate-pulse"></div>

            <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 flex flex-col md:flex-row items-center justify-between gap-16 relative z-10">
                <div className="flex-1 text-center md:text-left space-y-10 animate-fade-in-up">
                    <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-white/5 rounded-full border border-white/10 backdrop-blur-md">
                        <span className="w-2 h-2 rounded-full bg-green-500 animate-ping"></span>
                        <span className="text-green-500 font-bold tracking-[0.2em] text-xs uppercase">Available for Innovation</span>
                    </div>

                    <h1 className="text-6xl md:text-8xl font-black text-white tracking-tighter leading-[0.9]">
                        CRAFTING <br />
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 via-green-500 to-green-600 text-glow">
                            DIGITAL<br />EXCELLENCE
                        </span>
                    </h1>

                    <p className="text-xl md:text-2xl text-gray-400 max-w-2xl font-medium leading-relaxed">
                        I am <span className="text-white">Kwagala Moris Owen</span>, a Software Developer & IT Specialist from Uganda, transforming complex problems into elegant cross-platform solutions.
                    </p>

                    <div className="flex flex-wrap items-center gap-6 justify-center md:justify-start pt-6">
                        <a href="#projects" className="btn-primary group flex items-center gap-3">
                            Explore Work
                            <i className="bi bi-rocket-takeoff-fill transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"></i>
                        </a>
                        <a href="#contact" className="btn-outline group flex items-center gap-3">
                            Get In Touch
                            <i className="bi bi-chat-right-text-fill transition-transform group-hover:rotate-12"></i>
                        </a>
                    </div>
                </div>

                <div className="flex-1 relative w-full max-w-lg hidden lg:block">
                    <div className="relative aspect-square">
                        {/* Decorative Rings */}
                        <div className="absolute inset-0 border border-white/5 rounded-full animate-spin-slow"></div>
                        <div className="absolute -inset-4 border border-green-500/10 rounded-full animate-spin-slow" style={{ animationDirection: 'reverse' }}></div>

                        <div className="absolute inset-4 glass-card rounded-full p-2 border-white/20">
                            <div className="w-full h-full rounded-full overflow-hidden bg-neutral-900 border-4 border-black group">
                                <img
                                    src={profileImage}
                                    alt="Kwagala Moris Owen"
                                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                                />
                            </div>
                        </div>

                        {/* Floating Badges */}
                        <div className="absolute top-10 -right-4 glass-card px-6 py-4 rounded-3xl animate-bounce" style={{ animationDuration: '3s' }}>
                            <div className="flex items-center gap-3">
                                <div className="p-3 bg-green-500 rounded-xl text-black shadow-lg shadow-green-500/20">
                                    <i className="bi bi-heart-fill"></i>
                                </div>
                                <div>
                                    <p className="text-xs text-gray-400 font-bold uppercase">Experience</p>
                                    <p className="text-lg text-white font-black">Expert IT</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Scroll Indicator */}
            <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 animate-bounce">
                <span className="text-[10px] text-gray-500 uppercase tracking-[0.3em] font-bold">Scroll</span>
                <div className="w-px h-12 bg-gradient-to-b from-green-500 to-transparent"></div>
            </div>
        </section>
    );
}

export default Hero;
